

define(['jquery', 'squid', 'text!./template.html', 'components/xo-ui-components/src/dropdown/directive', 'components/xo-ui-components/src/dropdown-multiline/directive', 'components/xo-ui-components/src/error-tooltip/directive', 'components/xo-form-components/src/name-input/directive', 'components/xo-models/src/address/index', 'components/xo-form-components/src/zipcode/directive'], function ($, squid, template) {

    return squid.module('xo-add-address.directive', ['squid', 'xo-dropdown.directive', 'xo-dropdown-multiline.directive', 'xo-error-tooltip.directive', 'xo-name-input.directive', 'xomodel.address', 'xo-zipcode.directive']).directive('discriminate', function ($timeout, $parse) {
        // scans through the rendered elements within a container and
        // applies the supplied discriminator function to all the 'id'
        // and 'for' attributes. NOTE: Use the string 'baseId' when
        // entering the expression for the directive.
        //
        // e.g. discriminate='someDiscriminator(baseId)'
        //
        return {
            restrict: 'A',
            link: function link(scope, element, attrs) {
                // wait for the DOM to settle down
                $timeout(function () {
                    var discriminatorFn = $parse(attrs.discriminate);

                    $(element).find('[for],[id],[name]').each(function () {
                        // apply the discriminator to the attributes
                        var baseFor = $(this).attr('for');
                        var baseId = $(this).attr('id');
                        var baseName = $(this).attr('name');

                        if (baseFor) {
                            $(this).attr('for', discriminatorFn(scope, { baseId: baseFor }));
                        }

                        if (baseId) {
                            $(this).attr('id', discriminatorFn(scope, { baseId: baseId }));
                        }

                        if (baseName) {
                            $(this).attr('name', discriminatorFn(scope, { baseId: baseName }));
                        }
                    });
                });
            }
        };
    }).directive('xoAddAddress', function () {

        return {
            template: template,

            scope: {
                address: '=',
                isShipping: '=',
                country: '=',
                metadata: '@',
                hideButtonHandler: '=',
                hideCep: '=',
                hideName: '=',
                triggerZipCodeBlur: '=',
                triggerZipCodeKeyPress: '='
            },

            controller: function controller($scope, $populate, $rootScope, $locale, $window, $feature, $PrefillAddressModel, $MetadataModel) {

                var country = $scope.country || $scope.address && $scope.address.country;

                $scope.country = country;
                $scope.locale = $locale;
                $scope.metadata = $MetadataModel.create();

                // If the user changes their shipping/billing address country, fetch that metadata (if needed) and re-render.
                $scope.$watch('country', function setMetadata() {
                    $scope.metadata.choose($scope.country, $scope.locale.lang);
                });

                // If the user changes languagle toggle, fetch that metadata (if needed) and re-render.
                $scope.$on('contentChange', function setMetadata() {
                    $scope.metadata.choose($scope.country, $scope.locale.lang);
                });

                // this function is used on ids and fors in the template to add 'shipping' or 'billing'
                // in front of the identifier in camelCase. Use in conjunction with the 'discriminate' directive
                $scope.addPrefix = function (baseId) {
                    return ($scope.isShipping ? 'shipping' : 'billing') + baseId.replace(/^(.)/, function (match) {
                        return match[0].toUpperCase();
                    });
                };

                $scope.normalizeCountry = function (countryCode) {
                    return $feature('AddressFormat', countryCode, countryCode) || countryCode;
                };

                $scope.isAddPreferred = $feature('preferredShipping', false, $scope.country) && $scope.isShipping;

                $scope.isAddressLookupEnabled = $feature('addressLookup', false, $scope.country);
                var sortStates = $feature('sortStatesForAddress', false, $scope.country);

                $scope.isShowLookupFields = $scope.isAddressLookupEnabled;

                if ($scope.isShowLookupFields) {
                    // Show the Address Lookup Fields only when the hideButtonHandler function is passed by the caller.
                    if ($scope.hideButtonHandler) {
                        $scope.hideButtonHandler(true);
                    } else {
                        $scope.isShowLookupFields = false;
                    }
                }

                function getSortedStateList() {
                    var states = $locale.content.get(sortStates, {});
                    var statesList = [];
                    angular.forEach(states, function (key, value) {
                        statesList.push({
                            code: value,
                            sname: key
                        });
                    });

                    statesList.sort(function (a, b) {
                        return a.sname.localeCompare(b.sname);
                    });
                    $scope.sortedStatesList = statesList;
                }

                if (sortStates) {
                    getSortedStateList();
                }

                $scope.formatZip = function () {
                    var unformatted = $scope.address.postal_code.replace(/[^0-9]/gi, '');
                    var formatted = [['', unformatted.slice(0, 3)], ['-', unformatted.slice(3)]].map(function (x) {
                        return x[1] && x[0] + x[1] || '';
                    }).join('');
                    $scope.address.postal_code = formatted;
                };

                function getAddress(address) {
                    var COMMA = ', ';
                    var SPACE = ' ';
                    var line1, line2;

                    function prefix(str, prefixStr) {
                        if (str) {
                            return (prefixStr ? prefixStr : '') + str;
                        }
                        return '';
                    }

                    if (!address.deliveryAddresses || angular.isArray(address.deliveryAddresses) && address.deliveryAddresses.length === 0) {
                        // if deliveryAddresses is not an array or is empty
                        // line would be empty, hence return to caller.
                        return;
                    }

                    var array = address.deliveryAddresses;
                    if (array.length > 1) {
                        // populate line2 from the last element
                        line2 = array.pop();
                    }
                    line1 = array.join(COMMA);

                    var displayLine1 = line1 + prefix(line2, COMMA);
                    var displayLine2 = prefix(address.city) + prefix(address.state, COMMA) + prefix(address.postal_code, SPACE);
                    var displayLine3 = prefix(address.country);

                    return {
                        line1: line1,
                        line2: line2,
                        city: address.city,
                        state: address.state,
                        postal_code: address.postal_code,
                        country: address.country,

                        displayLine1: displayLine1,
                        displayLine2: displayLine2,
                        displayLine3: displayLine3,

                        dropDownAddress: displayLine1 + prefix(displayLine2, ' \\n ') + prefix(displayLine3, ' \\n ')
                    };
                }

                function populateAddressFormFields(address) {
                    $scope.address.line1 = address.line1;
                    $scope.address.line2 = address.line2;
                    $scope.address.city = address.city;
                    $scope.address.state = address.state;
                    $scope.address.postal_code = address.postal_code;
                    $scope.address.neighborhood = address.neighborhood;
                }

                /**
                 * Show error message and display the full-address fields
                 */
                function populateErrorMessage() {
                    var messages = [];
                    messages.push($scope.locale.content.get('addressBook.lookupError'));

                    $scope.lookupFailureMessage = {
                        msgs: messages,
                        type: 'warning'
                    };

                    $scope.isShowLookupFields = false;
                    $scope.isLookupFailure = true;
                }

                function processLookupResult(list) {
                    if (list.length > 1) {
                        // Show drop-down list of all addresses
                        $scope.isLookupSuccess = true;
                        $scope.isShowLookupDropDown = true;
                        $scope.lookupAddressList = list.map(function (addr) {
                            return getAddress(addr);
                        });
                    } else if (list.length === 1) {
                        // Show single address component
                        $scope.isLookupSuccess = true;
                        $scope.isShowLookupDropDown = false;

                        var address = getAddress(list[0]);
                        $scope.singleAddress = address;
                        populateAddressFormFields(address);
                    } else {
                        populateErrorMessage();
                    }
                }

                if ($scope.address) {
                    $scope.lastPrefilledZip = $scope.address.postal_code;
                }
                $scope.prefill = function () {
                    var cepPattern = /^(\d{5}-\d{3}|\d{5}|\d{8})$/;
                    var first_name;
                    var last_name;

                    if ($scope.lastPrefilledZip === $scope.address.postal_code || !cepPattern.test($scope.address.postal_code)) {
                        return;
                    }

                    if ($scope.isShipping) {
                        first_name = $scope.address.first_name;
                        last_name = $scope.address.last_name;
                    }

                    $scope.prefillAddress = new $PrefillAddressModel({
                        id: $scope.token,
                        address: {
                            country: $scope.address.country,
                            postal_code: $scope.address.postal_code
                        }
                    });

                    $scope.prefillAddress.save({
                        data: $scope.prefillAddress,

                        success: function success(result) {
                            if (result) {
                                populateAddressFormFields(result);
                                $scope.lastPrefilledZip = $scope.address.postal_code;
                                if ($scope.isShipping) {
                                    $scope.address.first_name = first_name;
                                    $scope.address.last_name = last_name;
                                }
                            }
                        }
                    });
                };

                $scope.findAddress = function () {
                    $scope.lookupAddress = $PrefillAddressModel.create($scope.token, {
                        address: {
                            country: $scope.address.country,
                            postal_code: $scope.address.postal_code,
                            house_number: $scope.address.house_number,
                            building_name: $scope.address.building_name
                        }
                    });

                    if (document.querySelector('#lookupZip.ng-invalid')) {
                        document.querySelector('#addressLookupFields').classList.add('validated');
                    } else {
                        $scope.isLookupProcessing = true;
                        $scope.lookupAddress.save({
                            data: $scope.lookupAddress,
                            silent: true,

                            success: function success(result) {
                                processLookupResult(result);
                                $scope.hideButtonHandler(false);
                            },

                            contingencies: {
                                INTERNAL_ERROR: populateErrorMessage
                            }
                        });
                    }
                };

                $scope.changeAddressDropDown = function () {
                    populateAddressFormFields($scope.address.selectedAddress);
                };

                $scope.showFullAddress = function () {
                    $scope.isShowLookupFields = false;
                    $scope.hideButtonHandler(false);
                };

                /**
                 * Pass an array of group names to retrieve the list of states
                 * e.g. ['england', 'northernIreland', 'scotland', 'wales', 'ukOffshoreDependencies']
                 */
                var stateNamesInGroup = [];
                $scope.retrieveStateNamesInGroup = function (groups) {
                    if (stateNamesInGroup.length) {
                        // Angular keeps watching for this method as its used in ng-model, hence return cached data.
                        return stateNamesInGroup;
                    }
                    var content = $locale.content;
                    angular.forEach(groups, function (group) {
                        var groupName = content.common[group];
                        var statesList = content[group];
                        angular.forEach(statesList, function (value, key) {
                            stateNamesInGroup.push({
                                key: key,
                                value: value,
                                group: groupName
                            });
                        });
                    });
                    return stateNamesInGroup;
                };

                $scope.zipCodeBlur = function () {
                    if ($scope.triggerZipCodeBlur) {
                        $rootScope.$emit('zip_code_blur');
                    }
                };

                $scope.zipCodeKeyPress = function (event) {
                    if ($scope.triggerZipCodeKeyPress) {
                        $rootScope.$emit('zip_code_keypress', { event: event });
                    }
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-address-components/src/add-address/directive.js
// module id = ./components/xo-address-components/src/add-address/directive.js
// module chunks = 1